import { useMutation } from '@tanstack/react-query'

import { api } from '../../../services/api'

export const useVerifyAccount = () =>
  useMutation({
    mutationFn: api.auth.verifyAccount,
    mutationKey: ['verify-account'],
  })
